import VehiclePage from './VehiclePage';

export default VehiclePage;



// WEBPACK FOOTER //
// ./src/components/pages/VehiclePage/index.js